import { PlayArrow as PlayArrowIcon } from "@mui/icons-material"

const MetricTrend = ({ trend }) => {
	if (!trend?.value) {
		return null
	}

	return (
		<div className={(trend.direction === "up") ? "scout-stat-card__trend scout-stat-card__trend--up" : "scout-stat-card__trend scout-stat-card__trend--down"}>
			<span>{trend.value}%</span>
			<PlayArrowIcon fontSize="inherit" />
		</div>
	)
}

export default MetricTrend
